export default "__VITE_ASSET__CGW5dmKu__"